export default "__VITE_ASSET___Si42gnt__"